import { Component } from 'react'
import { observer } from 'mobx-react'
import Lightbox from 'react-image-lightbox'

import * as h from 'h'

@observer(['UiStore'])
export default class LightboxImage extends Component {
  render () {
    const { image, UiStore } = this.props

    return h.div(null,
      h.img({ src: image, name: '' }),
      h.maybe(UiStore.lightboxIsVisible,
        h.h(Lightbox, {
          mainSrc: image,
          onCloseRequest: () => { UiStore.lightboxIsVisible = false }
        })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Popout/LightboxImage.js